module.exports = __webpack_public_path__ + "img/bottom_left_img.e9531dcf.png";